import { useState } from "react";

import ProjectsPage from "../Projects/ProjectsPage";

import { Filters, Search } from "../Table";

const { loadStore } = require("../../redux/store/localStorage");

const getCurrentClub = () => {
  try {
    return loadStore().currentClub || {};
  } catch (err) {
    return {};
  }
};

import { ProjectFilter } from "../Projects/__generated__/ProjectsPageQuery.graphql";

const filters: (ProjectFilter | null)[] = [
  null,
  "unassigned",
  "mine",
  "completed",
  "incompleted",
];

export default function ProjectsPageLoader() {
  const { currentClub } = getCurrentClub();
  const clubId = currentClub?.id;

  const [filter, setFilter] = useState<ProjectFilter | null>(null);
  const [search, setSearch] = useState<string | null>(null);

  return (
    <>
      {clubId && (
        <ProjectsPage
          clubId={clubId}
          setFilter={setFilter}
          filter={filter}
          search={search}
        >
          <div className="page-title-right">
            <div className='input-group'>
              <Search setSearch={setSearch} />
              <Filters<ProjectFilter> {...{ setFilter, filters, filter }} />
            </div>
          </div>
        </ProjectsPage>
      )}
    </>
  );
}
